import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const Page = forwardRef(({ children, title = "", ...other }, ref) => (
    <Box ref={ref} {...other}>
        <Helmet>
            <title>{title}</title>
        </Helmet>
        {children}
    </Box>
));

Page.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
};

export default Page;
